import client from 'src/graphql'
import { MeQuery, MeDocument } from 'src/generated/graphql'

export const loadUser = async () => {
  const { data } = await client.query<MeQuery>({ query: MeDocument })
  return data?.me
}
